import { render, staticRenderFns } from "./pgFavorite.vue?vue&type=template&id=12c5231b&scoped=true&"
import script from "./pgFavorite.vue?vue&type=script&lang=js&"
export * from "./pgFavorite.vue?vue&type=script&lang=js&"
import style0 from "./pgFavorite.vue?vue&type=style&index=0&id=12c5231b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c5231b",
  null
  
)

export default component.exports